import { IKnmReasonTypeSelectOption } from '../../../CorePackage/CatalogsModule/interfaces/IKnmReasonTypeSelectOption';
import { KnmReasonTypeNameEnum } from '../enums/KnmReasonTypeNameEnum';

export const isPassportReasonLinkRequired = (reasonType: IKnmReasonTypeSelectOption | undefined): boolean => {
  return !!reasonType && reasonType.name === KnmReasonTypeNameEnum.IMMEDIATE_CONTROL_PURCHASE;
};
